<template>
  <div id="page-user-view">
    <template v-if="common.getPermissions('financials', 'base', 'view')">
      <div class="relative p-[25px] border border-solid border-desired-dawn rounded-[6px] bg-white mt-[21px]">
        <span @click="fundTransfer()" class="cursor-pointer absolute ph ph-calendar-dots right-[16px] top-[16px] text-primary text-[20px]"></span>
        <div class="grid lg:grid-cols-4 md:grid-cols-2 grid-cols-1">
          <div>
            <p class="text-[16px] text-industrial-revolution underline cursor-pointer" @click="openBillingTab()">{{ $t('Last Statement') }}</p>
            <p class="mt-[6px] text-industrial-revolution flex flex-wrap gap-1 items-center vs-con-loading__container" id="last-statement-section">
              <span class="md:text-[24px] text-[20px] text-young-night">{{ statementLoading === true ? '' : statements.length > 0 ? $t(formatDate(statements[0].created).split(",")[0]) : $t('No statements available') }}</span>
              <span v-if="statements[0] && statements[0].created" class="text-[14px]">{{ '(' + formatDate(statements[0].created).split(" ")[1] + ')' }}</span>
            </p>
          </div>
          <div class="md:mt-0 mt-[23px]">
            <p class="text-[16px] text-industrial-revolution">{{ $t('Transfer Date') }}</p>
            <p class="text-industrial-revolution mt-[6px] flex flex-wrap gap-1 items-center"> 
              <span class="md:text-[24px] text-[20px] text-young-night">{{ $t(transferDay.day) }}</span> 
              <span class="text-[14px]">{{ '(' +  formatDate(transferDay.date).split(" ")[1] + ')' }}</span>
            </p>
          </div>
          <div class="md:mt-0 mt-[23px]">
            <p class="text-[16px] text-industrial-revolution">{{ $t('Cash on the way') }}</p>
            <p class="md:text-[24px] text-[20px] text-young-night mt-[6px]">{{ $t('EGP') }} {{ financials.cash_on_the_way.toLocaleString('en', { minimumFractionDigits: 2, maximumFractionDigits: 2}) }}</p>
          </div>
          <div class="md:mt-0 mt-[23px]">
            <p class="text-[16px] text-industrial-revolution">{{ $t('Next Statement') }}</p>
            <p class="text-industrial-revolution mt-[6px] flex flex-wrap gap-1 items-center">
              <span class="md:text-[24px] text-[20px] text-young-night">{{ $t(nextStatment.day) }}</span> 
              <span class="text-[14px]">{{ '(' +  formatDate(nextStatment.date).split(" ")[1] + ')' }}</span>
            </p>
          </div>
        </div>
        <div class="flex items-center gap-1 mt-5">
          <span class="material-icons-round text-base cursor-default">info</span>
          <span>{{$t('Please allow up to 3 business for statements to appear on your account.')}}</span>
        </div>
      </div>
      <div class="grid md:grid-cols-2 grid-cols-1 gap-[16px] mt-[16px] relative">
        <div class="relative p-[25px] border border-solid border-desired-dawn rounded-[6px] bg-white">
          <div class="flex items-center justify-between">
            <p class="md:text-[18px] text-[16px] text-young-night">{{ $t('Total Cash Balance') }}</p>
            <span @click="breakdownModal = true" class="underline text-primary cursor-pointer">{{ $t('Breakdown') }}</span>
          </div>
          <p class="md:text-[32px] text-[24px] text-young-night">{{ financials.available_cash_balance.toLocaleString('en', { minimumFractionDigits: 2, maximumFractionDigits: 2}) }}</p>
          <div class="mt-[52px] items-center col-span-2">
            <shipblu-button id="instant-payout-btn" :textButton="$t('Instant Payout')" @click="addInstantPayout()" class="sm:w-[250px] w-full"/>
          </div>
        </div>
        <div class="relative p-[25px] border border-solid border-desired-dawn rounded-[6px] bg-white">
          <p class="md:text-[18px] text-[16px] text-young-night">{{ $t('Wallet Balance') }}</p>
          <p class="md:text-[32px] text-[24px] text-young-night">{{ merchant.quickbooks_wallet_balance ? merchant.quickbooks_wallet_balance.toLocaleString('en', { minimumFractionDigits: 2, maximumFractionDigits: 2}) : '0.0' }}</p>
          <div class="mt-[52px] flex items-center gap-[10px]">
            <shipblu-button :color="merchant.is_self_signup && merchant.name === 'Entrepreneur Merchant' ? 'secondary' : 'primary'" :textButton="$t('Deposit')" @click="merchant.is_self_signup && merchant.name === 'Entrepreneur Merchant' ? topUpModal = false : checkAccountType()" 
              :disabled="merchant.is_self_signup && merchant.name === 'Entrepreneur Merchant' ? true : false" class="sm:w-[250px] w-full"/>
            <shipblu-button color="secondary" :textButton="$t('withdrawButton')" @click="withdrawalRequestModal = true" class="sm:w-[250px] w-full"/>
          </div>
        </div>
      </div>
      <div class="mt-[16px]">
        <div class="rounded-t-[6px] bg-white py-[15px] px-[24px] border border-solid border-gainsboro md:flex justify-between hidden mb-[-4px] relative z-[999]">
          <span class="text-young-night text-[16px]">{{ $t('Recent Transactions') }}</span>
          <!-- <span class="underline text-[14px] text-primary cursor-pointer" @click="$router.push({ query: {tab:'transactions'}})">{{ $t('View More') }}</span> -->
        </div>
        <shipblu-table
          orders
          :sst="true"
          :data="transactions"
          :tableLoader="tableLoader"
          :hideHeader="true"
        >
          <template slot="thead">
            <shipblu-th class="pl-[24px]">{{$t('Transaction Date')}}</shipblu-th>
            <shipblu-th>{{$t('Transaction Type')}}</shipblu-th>
            <shipblu-th>{{$t('Transaction Amount')}}</shipblu-th>
            <shipblu-th>{{$t('Transaction Status')}}</shipblu-th>
          </template>

          <template slot-scope="{ data }">
            <shipblu-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data" :color="`${getStyle(data[indextr])}`">
              <shipblu-td class="order-0" :data="data[indextr].name">
                <p class="sm:hidden block text-secondary text-sm mb-2">{{$t('Transaction Date')}}</p>
                <span class="sm:pl-[12px]">{{ formatTransactionDate(data[indextr].transaction_date) }}</span>
              </shipblu-td>

              <shipblu-td class="order-4" :data="data[indextr].type">
                <p class="sm:hidden block text-secondary text-sm mb-2">{{$t('Transaction Type')}}</p>
                <p class="capitalize">{{ data[indextr].type.replace('_', ' ')  }}</p>
              </shipblu-td>

              <shipblu-td class="order-5" :data="data[indextr].amount">
                <p class="sm:hidden block text-secondary text-sm mb-2">{{$t('Transaction Amount')}}</p>
                {{ $t(data[indextr].amount.toLocaleString('en', { minimumFractionDigits: 2, maximumFractionDigits: 2})) }}
              </shipblu-td>

              <shipblu-td class="order-12" :data="data[indextr].status" style="white-space: nowrap;">
                <p class="sm:hidden block text-secondary text-sm mb-2">{{$t('Transaction Status')}}</p>
                <div class="flex" style="width: fit-content;">
                  <span class="capitalize border border-solid rounded-4xl px-5 py-1.5 leading-none sm:text-sm text-xs text-white" :style="`background-color: ${getStyle(data[indextr])}`">{{ $t(getStatusLabel(data[indextr])) }}</span>
                </div>
              </shipblu-td>

            </shipblu-tr>
          </template>
        </shipblu-table>
        <shipblu-pagination :maximumItems="maximumItems" :noOptions="true" :totalRows="totalRows" :currentPage="currentPage" @currentPage="currentPage = $event" />
      </div>
      <top-up-method v-if="topUpModal" @topUpModal="topUpModal = $event" />
      <breakdown-modal :breakdownModal="breakdownModal" @breakdownModal="breakdownModal = $event" :financials="financials"></breakdown-modal>
      <withdrawal-request-modal :withdrawalRequestModal="withdrawalRequestModal" :walletbalance="merchant.quickbooks_wallet_balance" @withdrawalRequestModal="withdrawalRequestModal = $event"></withdrawal-request-modal>
      <instant-payout-modal :instant="instant" v-if="instantPayoutModal" @instantPayoutModal="instantPayoutModal = $event" />
    </template>

    <template v-else>
      <NoPermission class="mt-6" :action="$t('view this page')"/>
    </template>
  </div>
</template>

<script>
import {sendRequest} from './../../http/axios/requestHelper.js'
import common  from '@/assets/utils/common'
import i18nData from './../../i18n/i18nData.js'
import TopUpMethod from './components/TopUpMethod.vue'
import BreakdownModal from '../components/BreakdownModal.vue'
import WithdrawalRequestModal from '../components/WithdrawalRequestModal.vue'
import ShipbluTable from './../../layouts/components/NewShipBluTable.vue'
import ShipbluTr from './../../layouts/components/ShipBluTr.vue'
import ShipbluTh from './../../layouts/components/ShipBluTh.vue'
import ShipbluTd from './../../layouts/components/ShipBluTd.vue'
import InstantPayoutModal from './components/InstantPayoutModal.vue'
import ShipbluPagination from '../../layouts/components/ShipbluPagination.vue'
import NoPermission from './components/NoPermission.vue'

export default {
  data () {
    return {
      common,
      maximumItems: process.env.VUE_APP_MAXIMUM_ITEMS_TABLE,
      offset: 0,
      totalRows: 0,
      currentPage: (this.$route.query.page &&  Number(this.$route.query.page) > 0) ? Number(this.$route.query.page) : 1,
      statements: [],
      nextStatment: {
        day: '',
        date: ''
      },
      bankTransferDays: [],
      daysDic: {},
      financials: {
        cash_collection_balance: 0.0,
        service_fees_due: 0.0,
        refunds_in_progress: 0.0,
        cash_on_the_way: 0.0,
        amounts_on_hold: 0,
        available_cash_balance: 0.0
      },
      merchant: {},
      topUpModal: false,
      breakdownModal: false,
      withdrawalRequestModal: false,
      tableLoader: true,
      transactions: [],
      instantPayoutModal: false,
      instant: {
        available_cod: 0.0,
        service_fees_due: 0.0,
        on_hold_amount: 0.0,
        instant_payout_fees: 0.0,
        transfer_fees: 0.0,
        payout_amount: 0.0
      },
      routeQuery: {},
      statementLoading: true,
      transferDay: {
        day: '',
        date: ''
      }
    }
  },
  watch: {
    currentPage () {
      this.offset = (this.currentPage - 1) * this.maximumItems
      this.$router.push({
        query: {
          ...this.$route.query,
          page: this.currentPage
        }
      }).catch(() => {})
      this.loadTransactionsHistory()
    }
  },
  methods: {
    getOrderStatusColor (order) {
      return common.getOrderStatusColor(this.getStatusLabel(order))
    },
    getStatusLabel (order) {
      return common.getStatusLabel(order, this.$store.state.AppActiveUser.userRole)
    },
    fundTransfer () {
      window.open(this.$i18n.locale === 'en' ? 'https://support.shipblu.com/en/support/solutions/articles/154000196090-billing-days-transfer-cycle-and-fees' : 'https://support.shipblu.com/ar/support/solutions/articles/154000196090-%D8%AF%D9%88%D8%B1%D8%A9-%D8%AA%D8%AD%D9%88%D9%8A%D9%84-%D8%A7%D9%84%D8%AA%D8%AD%D8%B5%D9%8A%D9%84%D8%A7%D8%AA', '_blank')
    },
    openBillingTab () {
      this.$router.push({
        query: {
          tab: 'billing',
          subTab: 'statements'
        }
      }).catch(() => {})
    },
    loadStatements () {
      if (document.querySelector('#last-statement-section')) {
        this.$vs.loading({
          background: this.backgroundLoading,
          color: this.colorLoading,
          container: '#last-statement-section',
          scale: 0.45
        })
      }
      this.tableLoader = true
      sendRequest(true, false, this, `api/v1/billing/statements/?merchant=${this.merchant.id}&limit=1`, 'get', null, true, 
        (response) => {
          this.statements = response.data.results
          this.statementLoading = false
          this.$vs.loading.close('#last-statement-section > .con-vs-loading')
        }, (error) => {
          this.statementLoading = false
          common.notifyResponseError(this, error)
          this.$vs.loading.close('#last-statement-section > .con-vs-loading')
        }
      )
    },
    loadDay () {
      this.daysLoader = true
      sendRequest(true, false, this, 'api/v1/subscriptions/pickup-days/', 'get', null, true,
        (response) => {
          response.data.map(item => { this.daysDic[item.id] = item.day })
          this.transferDays()
          this.showNextDayStatement()
        }
      )
    },
    transferDays () {
      const reversrFrontToBackDays = { 0: 2, 1: 3, 2: 4, 3: 5, 4: 6, 5: 0, 6: 1 }
      let todayAccToDB = ''
      let dayNumber = ''
      switch (this.merchant.transfer_days) {
      case '1 Transfer - Wednesday':
        this.bankTransferDays = [5] // Wednesday
        this.statementsDays = [2]
        this.nextStatment = {
          day: 'Saturday',
          date: this.getNextDayDate('Saturday')
        }
        this.transferDay = {
          day: 'Wednesday',
          date: this.getNextDayDate('Wednesday')
        }
        break

      case '1 Transfer - Monday':
        this.bankTransferDays = [3] // Monday
        this.statementsDays = [2]
        this.nextStatment = {
          day: 'Saturday',
          date: this.getNextDayDate('Saturday')
        }
        this.transferDay = {
          day: 'Wednesday',
          date: this.getNextDayDate('Wednesday')
        }
        break

      case '2 Transfers':
        this.bankTransferDays = [3, 5] // Monday, Wednesday
        this.statementsDays = [2]
        
        this.nextStatment = {
          day: 'Saturday',
          date: this.getNextDayDate('Saturday')
        }

        todayAccToDB = reversrFrontToBackDays[new Date().getDay()]
        dayNumber = this.bankTransferDays.find(n => n > todayAccToDB) || this.bankTransferDays[0]
        this.transferDay = {
          day: this.daysDic[dayNumber],
          date: this.getNextDayDate(this.daysDic[dayNumber])
        }
        break

      case '3 Transfers':
        this.bankTransferDays = [3, 5, 2] // Monday, Wednesday, Sunday
        this.statementsDays = [2, 4, 6] // Sunday, Tuesday, Thursday
        todayAccToDB = reversrFrontToBackDays[new Date().getDay()]
        // get next statement day
        dayNumber = this.statementsDays.find(n => n > todayAccToDB) || this.statementsDays[0]
        this.nextStatment = {
          day: this.daysDic[dayNumber],
          date: this.getNextDayDate(this.daysDic[dayNumber])
        }
        // get billing day
        dayNumber = this.bankTransferDays.find(n => n > todayAccToDB) || this.bankTransferDays[0]
        this.transferDay = {
          day: this.daysDic[dayNumber],
          date: this.getNextDayDate(this.daysDic[dayNumber])
        }
        break
      default:
        break
      }
    },
    getNextDayDate (dayName) {
      const daysOfWeek = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
      const today = new Date()
      const todayIndex = today.getDay() // 0 (Sunday) to 6 (Saturday)
      const targetIndex = daysOfWeek.findIndex(
        d => d.toLowerCase() === dayName.toLowerCase()
      )
      if (targetIndex === -1) {
        throw new Error('Invalid day name')
      }
      // Calculate how many days until the target day
      let diff = (targetIndex - todayIndex + 7) % 7
      if (diff === 0) diff = 7 // If today is the day, return next week
      const nextDate = new Date(today)
      nextDate.setDate(today.getDate() + diff)
      return nextDate
    },
    getStyle (data) {
      return common.getOrderStatusColor(data.status)
    },
    changeFormate (oldFromat) {
      const today = oldFromat
      const yyyy = today.getFullYear()
      let mm = today.getMonth() + 1
      let dd = today.getDate()
      if (dd < 10) dd = `0${dd}`
      if (mm < 10) mm = `0${mm}`
      return `${dd}/${mm}/${yyyy}`
    },
    formatDate (isoString) {
      if (!isoString) return ''
      const date = new Date(isoString)
      const options = { weekday: 'long' } // Get the full day name
      const dayName = new Intl.DateTimeFormat('en-GB', options).format(date)
      const day = date.getDate()
      const month = date.getMonth() + 1 // Months are 0-based
      const year = date.getFullYear()
      return `${dayName}, ${day}/${month}/${year}`
    },
    formatTransactionDate (isoString) {
      if (!isoString) return ''
      const normalized = isoString.replace(/(\.\d{3})\d+/, '$1')
      const date = new Date(normalized)
      if (Number.isNaN(date.getTime())) return ''
      return date.toLocaleDateString('en-CA')
    },
    loadFinancials () {
      this.tableLoader = true
      sendRequest(true, false, this, 'api/v1/analytics/merchant/dashboard/financial-center/', 'get', null, true, 
        (response) => {
          this.financials = response.data
          this.tableLoader = false
        }
      )
    },
    isBillingDay () {
      const now = new Date()
      // Get the current day of the week (Saturday = 1, Sunday = 2, ..., Thursday = 6, Friday = 7)
      const currentDay = new Intl.DateTimeFormat('en-US', {
        timeZone: 'Africa/Cairo',
        weekday: 'long'
      }).format(now)
      const dayMap = {
        Saturday: 1,
        Sunday: 2,
        Monday: 3,
        Tuesday: 4,
        Wednesday: 5,
        Thursday: 6,
        Friday: 7
      }
      const todayIndex = dayMap[currentDay]
      return this.merchant.billing_days ? this.merchant.billing_days.includes(todayIndex) : ''
    },
    checkAccountType () {
      if (this.merchant.has_tax_profile) {
        this.topUpModal = true
      } else {
        this.$vs.dialog({
          color: 'danger',
          title: i18nData[this.$i18n.locale]['Oops!'],
          text: i18nData[this.$i18n.locale]['You don\'t have a tax profile to perform this action!'],
          acceptText: i18nData[this.$i18n.locale]['Choose Account type'],
          accept: this.goToAddTaxProfile
        })
      }
    },    
    getEgyptTime () {
      const egyptTimeZone = 'Africa/Cairo'
      const now = new Date()
      const daysOptions = { timeZone: egyptTimeZone, weekday: 'long' }
      const egyptDay = now.toLocaleDateString('en-US', daysOptions)

      const hoursOptions = { timeZone: egyptTimeZone, hour: '2-digit', minute: '2-digit', hour12: false }
      const egyptTime = now.toLocaleTimeString('en-US', hoursOptions)
      return [egyptTime, egyptDay]
    },
    addInstantPayout () {
      if ((Number(this.getEgyptTime()[0].split(':')[0]) >= 7 && Number(this.getEgyptTime()[0].split(':')[0]) < 12) && this.getEgyptTime()[1] !== 'Friday' && this.getEgyptTime()[1] !== 'Saturday') {
        this.$vs.loading({
          background: this.backgroundLoading,
          color: this.colorLoading,
          container: '#instant-payout-btn',
          scale: 0.45
        })
        sendRequest(true, false, this, 'api/v1/instant/payouts/?dry_run=True', 'get', null, true,
          (response) => {
            this.instant = response.data
            this.instant.instant_payout_fees_percentage = (this.instant.instant_payout_fees / this.instant.max_payout_amount * 100).toFixed(2)
            this.instantPayoutModal = true
            this.$vs.loading.close('#instant-payout-btn > .con-vs-loading')
          }, (error) => {
            common.notifyResponseError(this, error)
            this.$vs.loading.close('#instant-payout-btn > .con-vs-loading')
          }
        )
      } else {
        this.$vs.notify({
          color:'warning',
          title: i18nData[this.$i18n.locale]['Warning'],
          text: 'Instant Payout should be requested before 11 AM',
          position: 'top-center'
        })
      }
    },
    loadTransactionsHistory () {
      sendRequest(true, false, this, `api/v1/accounting/merchant-financial-events/?offset=${this.offset}&limit=${this.maximumItems}`, 'get', null, true, 
        (response) => {
          this.transactions = response.data.results
          this.totalRows = response.data.count
          this.tableLoader = false
        }, () => {}
      )
    }
  },
  components: {
    TopUpMethod,
    BreakdownModal,
    WithdrawalRequestModal,
    ShipbluTable,
    ShipbluTr,
    ShipbluTh,
    ShipbluTd,
    InstantPayoutModal,
    ShipbluPagination,
    NoPermission
  },
  created () {
    this.routeQuery = { ...this.$route.query };
    ['subTab', 'filter'].forEach(key => delete this.routeQuery[key])
    this.$router.push({ query: { ...this.routeQuery } }).catch(() => {})
    this.offset = (this.currentPage - 1) * this.maximumItems
    if (common.getPermissions('financials', 'base', 'view')) {
      const merchantData = common.checkMerchantInLocalStorage(this)
      merchantData.then(results => {
        this.merchant = results.merchantData
        this.loadStatements()
        this.loadDay()
        this.loadFinancials()
        this.loadTransactionsHistory()
      })
    }
  }
}
</script>
